// Neuvottelulabra (#1395, /labs/metsaneuvottelu) — the `negotiationLab` namespace.
// Its own file so the lab's strings grow here, not in fi.js / en.js / sv.js.

export const negotiationLabFi = {
  eyebrow: "Labra · Metsäneuvottelu",
  title: "Kenen metsä? Ristiriidat ja kompromissit",
  lead: "Tekoälypersoonat edustavat sidosryhmiä, joiden tavoitteet ovat ristiriidassa. Säädä metsien käyttöä ja katso, kuka on tyytyväinen, kenen punainen viiva ylittyy ja millainen ratkaisu olisi reiluin.",
  loading: "Ladataan esiasetusta…",
  loadError: "Esiasetuksen lataus epäonnistui: {{message}}",
  tabs: { mixer: "Metsämikseri", redLines: "Punaiset viivat", veil: "Tietämättömyyden verho", hybrids: "Hybridit ja Suomen tase" },
  hybrids: {
    title: "Hybridit",
    intro: "Valitse kaksi ratkaisua, jotka vetävät toisiaan vastaan. Tekoäly luonnostelee hybridejä, jotka säilyttävät kummastakin sen, mikä on tärkeintä, ja arvioi, miten kukin sidosryhmä ottaisi jokaisen vaihtoehdon vastaan. Merkittynä on se, jota vähiten vastustetaan, ei vain suosituin.",
    pairLabel: "Ristiriitainen ratkaisupari",
    draft: "Luo hybridit",
    draftAgain: "Luo uudet hybridit",
    drafting: "Tekoäly luonnostelee hybridejä…",
    error: "Hybridien luonti epäonnistui: {{message}}",
    needPersonas: "Luo ensin persoonat: tuki arvioidaan niiden tavoitteista.",
    fromA: "A:sta: {{text}}",
    fromB: "B:stä: {{text}}",
    objection: "Vahvin vastaväite ({{name}}): {{text}}",
    mark: { least: "Vähiten vastustettu", popular: "Suosituin" },
    support: "Tuki sidosryhmittäin",
    objections: "Vastustajia",
    total: "Yhteensä",
    legend: "−2 vastustaa jyrkästi, −1 vastustaa, 0 hyväksyy, +1 kannattaa, +2 kannattaa vahvasti.",
    balanceTitle: "Suomen tase",
    balanceIntro: "Sama kysymys yhden sidosryhmän yläpuolelta: mitä kukin vaihtoehto tekee koko Suomelle ja maailmalle? Mukana hiilivuoto: jos Suomi tekee vähemmän, mihin tuotanto siirtyy, ja jos enemmän, mitä se korvaa.",
    balance: "Laske Suomen tase",
    balanceAgain: "Laske uudelleen",
    balancing: "Tekoäly arvioi…",
    balanceError: "Arvio epäonnistui: {{message}}",
    unsourced: "Tekoälyn arvio ilman lähteitä: labraan ei ole liitetty tutkimusaineistoa. Haalea solu tarkoittaa matalaa varmuutta; vie hiiri solun päälle nähdäksesi perustelun.",
    scope: { national: "Suomi", global: "Maailma" },
    confidence: { low: "varmuus matala", medium: "varmuus kohtalainen", high: "varmuus korkea" },
    leakage: "Hiilivuoto ja siirtyvä hakkuupaine",
  },
  veil: {
    title: "Tietämättömyyden verho",
    intro: "Jokainen persoona asettaa ratkaisut järjestykseen kahdesti: ensin omana itsenään, sitten verhon takana, tietämättä, kenen asemaan se Suomessa päätyy, vai syntyykö se vasta vuonna 2060. Kun kukaan ei puolusta omaa paikkaansa, mikä nousee ja mikä laskee?",
    vote: "Äänestä verhon takana",
    voteAgain: "Äänestä uudelleen",
    voting: "Persoonat äänestävät…",
    error: "Äänestys epäonnistui: {{message}}",
    missing: "Näiden järjestys jäi vajaaksi, joten se ei ole mukana: {{names}}",
    needPersonas: "Luo ensin persoonat: äänestykseen tarvitaan vähintään kaksi.",
    ownRound: "Omana itsenä",
    veilRound: "Verhon takana",
    agreement: "Yksimielisyys: omana itsenä → verhon takana",
    agreementHint: "Persoonien järjestysten keskimääräinen korrelaatio: 1 on täysin sama järjestys, 0 ei yhteyttä, −1 vastakkainen.",
    perPersona: "Mikä muuttui kunkin kohdalla",
    topPick: "Ykkönen: {{own}} → {{veil}}",
  },
  redLines: {
    title: "Punaiset viivat",
    intro: "Jokaisella akselilla näkyy, mihin asti kukin sidosryhmä joustaa (punainen viiva) ja mitä se tavoittelee (piste). Vihreä alue on se, jonka kaikki hyväksyvät. Jos aluetta ei ole, punaiset viivat menevät ristiin, ja joku on hyvitettävä toisella akselilla.",
    zone: "Yhteinen alue: {{lo}} – {{hi}}",
    noZone: "Ei yhteistä aluetta: {{a}} ja {{b}} eivät kohtaa",
    noLines: "Kukaan ei vedä tälle akselille punaista viivaa.",
    today: "nyt",
    legend: { redLine: "punainen viiva", ideal: "tavoite", zone: "yhteinen alue", today: "nykytila" },
    packagesTitle: "Pakettiratkaisut",
    packagesIntro: "Tekoäly ehdottaa vaihtokauppoja akselien yli: joku joustaa siinä, mikä on sille vähemmän tärkeää, ja saa siinä, mikä on sille tärkeintä. Jokainen paketti tarkistetaan mikserin mallilla jokaista punaista viivaa vasten.",
    propose: "Ehdota pakettiratkaisuja",
    proposeAgain: "Ehdota uusia paketteja",
    proposing: "Tekoäly muotoilee paketteja…",
    error: "Pakettien ehdottaminen epäonnistui: {{message}}",
    needPersonas: "Luo ensin persoonat: paketit rakennetaan niiden tavoitteista ja punaisista viivoista.",
    gives: "joustaa",
    gets: "saa",
    checkOk: "Tarkistus: kenenkään punainen viiva ei ylity.",
    checkBreached: "Tarkistus: punainen viiva ylittyy {{count}} sidosryhmällä: {{names}}",
    overCeiling: "Tarkistus: paketti ylittää kestävän puunsaannin katon.",
    levers: "Puunkäyttö {{harvest}}, suojelu {{protected}} %, sellu {{pulp}} %, sahatavara {{solid}} %, uudet biotuotteet {{newBio}} %",
    tryInMixer: "Kokeile mikserissä",
  },
  personas: {
    title: "Sidosryhmät",
    intro: "Jokaisella sidosryhmällä on persoona: mitä se tavoittelee, mikä sille on tärkeää ja mistä se ei jousta.",
    generate: "Luo persoonat",
    regenerate: "Luo uudet persoonat",
    generating: "Tekoäly luo persoonia…",
    error: "Persoonien luonti epäonnistui: {{message}}",
    missing: "Tekoäly ei luonut persoonaa näille: {{names}}",
    none: "Persoonia ei ole vielä luotu. Mikseri toimii ilmankin, mutta tyytyväisyysmittarit tarvitsevat persoonat.",
    cares: "Tärkeintä",
    ideal: "tavoite {{value}}",
    redLine: "punainen viiva {{value}}",
    noRedLine: "ei punaista viivaa",
  },
  mixer: {
    title: "Metsämikseri",
    intro: "Liukusäätimillä jaetaan vuoden puunkäyttö ja suojelu. Jokainen muutos näkyy heti kansallisissa luvuissa ja sidosryhmien tyytyväisyydessä.",
    levers: "Säätimet",
    harvest: "Teollisuuden puunkäyttö",
    protected: "Suojeltu osuus metsistä",
    split: "Mihin puu menee",
    route: { pulp: "Sellu ja kartonki", solid: "Sahatavara ja vaneri", newBio: "Uudet biotuotteet" },
    outcome: "Suomen luvut",
    today: "nyt {{value}}",
    ceiling: "Kestävän puunsaannin katto: {{value}} Mm³/v",
    overCeiling: "Puunkäyttö ylittää kestävän puunsaannin katon tällä suojelutasolla.",
    jump: {
      baseline: "Nykytila",
      maximin: "Reiluin kompromissi",
      total: "Suurin kokonaishyöty",
    },
    jumpHint: {
      maximin: "Etsii sekoituksen, jossa mahdollisimman harvan punainen viiva ylittyy ja heikoimmin pärjäävä on mahdollisimman tyytyväinen.",
      total: "Etsii sekoituksen, jossa tyytyväisyyksien summa on suurin, vaikka joku jäisi punaisen viivansa taakse.",
    },
    fromPackage: "Pakettiratkaisu Punaisista viivoista: {{title}}",
    searching: "Etsitään…",
    noFit: "Yksikään sekoitus ei mahdu kestävän puunsaannin katon alle.",
    gauges: "Tyytyväisyys",
    gaugesEmpty: "Luo persoonat nähdäksesi, miten kukin sidosryhmä kokee valitun sekoituksen.",
    status: { red: "Punainen viiva ylittyy", amber: "Tyytymätön", green: "Tyytyväinen" },
    breached: "Ylittyy: {{axes}}",
    summary: "Tyytyväisyys yhteensä {{total}} / {{count}} · heikoimmin pärjäävä {{min}} %",
  },
  axis: {
    harvest: "Puunkäyttö",
    exports: "Vientitulot",
    jobs: "Työpaikat",
    climate: "Metsämaan nettopäästöt",
    protected: "Suojelu",
    newBio: "Uusien biotuotteiden osuus",
  },
  unit: { harvest: "Mm³/v", exports: "mrd €", jobs: "t. henkeä", climate: "Mt CO₂e", protected: "%", newBio: "%" },
  climateNote: "Positiivinen luku on päästölähde, negatiivinen nielu.",
  assumptions: {
    title: "Mallin oletukset",
    intro: "Lähtöluvut ovat tilastoista. Kertoimet ovat mallin oletuksia, jotka on viritetty toistamaan nykytila. Malli havainnollistaa vaihtokauppoja, se ei ennusta.",
    exportPerM3: "Vientiarvo kuutiota kohden: sellu ja kartonki {{pulp}} €, sahatavara ja vaneri {{solid}} €, uudet biotuotteet {{newBio}} €.",
    jobsPerMm3: "Työpaikat miljoonaa kuutiota kohden: metsätalous {{forestry}} t., teollisuus {{industry}} t., uudet biotuotteet {{newBio}} t.",
    climatePerMm3: "Jokainen miljoona kuutiota nykytasoa enemmän hakattua puuta lisää metsämaan nettopäästöjä {{value}} Mt CO₂e.",
    productStorage: "Pitkäikäiset puutuotteet varastoivat hiiltä: {{value}} Mt CO₂e miljoonaa sahatavaraan ohjattua kuutiota kohden.",
    newBioValue: "Uusien biotuotteiden arvo ja työllisyys ovat arvioita tuotteista, joita on vasta vähän markkinoilla.",
    newBioCap: "Uusiin biotuotteisiin voi ohjata enintään {{value}} % puusta: markkinat ja tekniikka eivät vielä kanna enempää.",
    ceiling: "Kestävän puunsaannin katto on suurin kestävä hakkuukertymä nykyisellä suojelutasolla, ja se pienenee suojelun kasvaessa.",
    sources: "Lähteet",
  },
};

export const negotiationLabEn = {
  eyebrow: "Lab · Forest negotiation",
  title: "Whose forest? Conflicts and compromises",
  lead: "AI personas stand in for stakeholders whose goals collide. Adjust how the forests are used and see who is satisfied, whose red line is crossed and what the fairest outcome would be.",
  loading: "Loading the preset…",
  loadError: "Could not load the preset: {{message}}",
  tabs: { mixer: "Forest mixer", redLines: "Red lines", veil: "Veil of ignorance", hybrids: "Hybrids and Finland's balance" },
  hybrids: {
    title: "Hybrids",
    intro: "Pick two solutions that pull against each other. The AI drafts hybrids that keep what matters most in each, and estimates how each stakeholder would receive every option. The one marked is the one fewest oppose, not only the most popular.",
    pairLabel: "Conflicting pair of solutions",
    draft: "Create hybrids",
    draftAgain: "Create new hybrids",
    drafting: "The AI is drafting hybrids…",
    error: "Creating the hybrids failed: {{message}}",
    needPersonas: "Create the personas first: support is judged from their goals.",
    fromA: "From A: {{text}}",
    fromB: "From B: {{text}}",
    objection: "Strongest objection ({{name}}): {{text}}",
    mark: { least: "Least opposed", popular: "Most popular" },
    support: "Support by stakeholder",
    objections: "Opposed by",
    total: "Total",
    legend: "−2 strongly opposes, −1 opposes, 0 can live with it, +1 supports, +2 strongly supports.",
    balanceTitle: "Finland's balance",
    balanceIntro: "The same question from above any one stakeholder: what does each option do for Finland as a whole, and for the world? Carbon leakage included: if Finland does less, where does production move, and if more, what does it replace?",
    balance: "Work out Finland's balance",
    balanceAgain: "Work it out again",
    balancing: "The AI is assessing…",
    balanceError: "The assessment failed: {{message}}",
    unsourced: "The AI's estimate without sources: no research dataset is attached to the lab. A faint cell means low confidence; hover over a cell for the reason.",
    scope: { national: "Finland", global: "The world" },
    confidence: { low: "low confidence", medium: "medium confidence", high: "high confidence" },
    leakage: "Carbon leakage and displaced harvesting",
  },
  veil: {
    title: "Veil of ignorance",
    intro: "Each persona ranks the solutions twice: first as itself, then behind the veil, not knowing whose place in Finland it will end up in, or whether it will only be born in 2060. When nobody defends their own seat, what rises and what falls?",
    vote: "Vote behind the veil",
    voteAgain: "Vote again",
    voting: "The personas are voting…",
    error: "The vote failed: {{message}}",
    missing: "These rankings were incomplete and are left out: {{names}}",
    needPersonas: "Create the personas first: a vote needs at least two.",
    ownRound: "As themselves",
    veilRound: "Behind the veil",
    agreement: "Agreement: as themselves → behind the veil",
    agreementHint: "The mean correlation between the personas' rankings: 1 is the same order, 0 unrelated, −1 opposite.",
    perPersona: "What changed for each",
    topPick: "First choice: {{own}} → {{veil}}",
  },
  redLines: {
    title: "Red lines",
    intro: "Each axis shows how far each stakeholder will go (the red line) and what it is after (the dot). The green band is what everyone accepts. Where there is none, the red lines cross, and someone has to be compensated on another axis.",
    zone: "Common ground: {{lo}} – {{hi}}",
    noZone: "No common ground: {{a}} and {{b}} do not meet",
    noLines: "Nobody draws a red line on this axis.",
    today: "today",
    legend: { redLine: "red line", ideal: "ideal", zone: "common ground", today: "today" },
    packagesTitle: "Package deals",
    packagesIntro: "The AI proposes trades across axes: a stakeholder gives where it matters less to it and gains where it matters most. Every package is checked with the mixer's model against every red line.",
    propose: "Propose package deals",
    proposeAgain: "Propose new packages",
    proposing: "The AI is drafting packages…",
    error: "Proposing packages failed: {{message}}",
    needPersonas: "Create the personas first: the packages are built from their goals and red lines.",
    gives: "gives",
    gets: "gets",
    checkOk: "Check: no stakeholder's red line is crossed.",
    checkBreached: "Check: the red line is crossed for {{count}} stakeholders: {{names}}",
    overCeiling: "Check: the package exceeds the sustainable supply ceiling.",
    levers: "Wood use {{harvest}}, protection {{protected}}%, pulp {{pulp}}%, sawn goods {{solid}}%, new bio-products {{newBio}}%",
    tryInMixer: "Try in the mixer",
  },
  personas: {
    title: "Stakeholders",
    intro: "Each stakeholder has a persona: what it is after, what matters to it and where it will not give way.",
    generate: "Create personas",
    regenerate: "Create new personas",
    generating: "The AI is creating personas…",
    error: "Creating the personas failed: {{message}}",
    missing: "The AI created no persona for: {{names}}",
    none: "No personas yet. The mixer works without them, but the satisfaction gauges need them.",
    cares: "Matters most",
    ideal: "ideal {{value}}",
    redLine: "red line {{value}}",
    noRedLine: "no red line",
  },
  mixer: {
    title: "Forest mixer",
    intro: "The sliders divide the year's wood use and set the level of protection. Every change shows at once in the national figures and in each stakeholder's satisfaction.",
    levers: "Levers",
    harvest: "Forest industry wood use",
    protected: "Share of forest protected",
    split: "Where the wood goes",
    route: { pulp: "Pulp and board", solid: "Sawn goods and plywood", newBio: "New bio-products" },
    outcome: "Finland's figures",
    today: "today {{value}}",
    ceiling: "Sustainable supply ceiling: {{value}} Mm³/yr",
    overCeiling: "Wood use exceeds the sustainable supply ceiling at this level of protection.",
    jump: {
      baseline: "Today",
      maximin: "Fairest compromise",
      total: "Largest total benefit",
    },
    jumpHint: {
      maximin: "Finds the mix that crosses as few red lines as possible and leaves the worst-off as satisfied as possible.",
      total: "Finds the mix with the highest sum of satisfaction, even if someone ends up past their red line.",
    },
    fromPackage: "Package deal from Red lines: {{title}}",
    searching: "Searching…",
    noFit: "No mix fits under the sustainable supply ceiling.",
    gauges: "Satisfaction",
    gaugesEmpty: "Create personas to see how each stakeholder sees the chosen mix.",
    status: { red: "Red line crossed", amber: "Dissatisfied", green: "Satisfied" },
    breached: "Crossed: {{axes}}",
    summary: "Total satisfaction {{total}} / {{count}} · worst-off at {{min}}%",
  },
  axis: {
    harvest: "Wood use",
    exports: "Export income",
    jobs: "Jobs",
    climate: "Forest land net emissions",
    protected: "Protection",
    newBio: "Share to new bio-products",
  },
  unit: { harvest: "Mm³/yr", exports: "bn €", jobs: "k people", climate: "Mt CO₂e", protected: "%", newBio: "%" },
  climateNote: "A positive figure is an emission source, a negative one a sink.",
  assumptions: {
    title: "The model's assumptions",
    intro: "The starting figures are statistics. The coefficients are the model's assumptions, tuned to reproduce today. The model illustrates trade-offs; it does not forecast.",
    exportPerM3: "Export value per m³: pulp and board €{{pulp}}, sawn goods and plywood €{{solid}}, new bio-products €{{newBio}}.",
    jobsPerMm3: "Jobs per million m³: forestry {{forestry}}k, industry {{industry}}k, new bio-products {{newBio}}k.",
    climatePerMm3: "Each million m³ harvested above today's level adds {{value}} Mt CO₂e to forest land net emissions.",
    productStorage: "Long-lived wood products store carbon: {{value}} Mt CO₂e per million m³ moved into sawn goods.",
    newBioValue: "The value and jobs of new bio-products are estimates for products that are only starting to reach the market.",
    newBioCap: "At most {{value}}% of the wood can go to new bio-products: markets and technology cannot carry more yet.",
    ceiling: "The sustainable supply ceiling is the largest sustainable felling at today's protection, and it shrinks as protection grows.",
    sources: "Sources",
  },
};

export const negotiationLabSv = {
  eyebrow: "Labb · Skogsförhandling",
  title: "Vems skog? Konflikter och kompromisser",
  lead: "AI-personor företräder intressenter vars mål krockar. Justera hur skogarna används och se vem som är nöjd, vems röda linje passeras och vilken lösning som vore rättvisast.",
  loading: "Laddar förinställningen…",
  loadError: "Förinställningen kunde inte laddas: {{message}}",
  tabs: { mixer: "Skogsmixern", redLines: "Röda linjer", veil: "Okunnighetens slöja", hybrids: "Hybrider och Finlands balans" },
  hybrids: {
    title: "Hybrider",
    intro: "Välj två lösningar som drar åt olika håll. AI:n skissar hybrider som behåller det viktigaste i båda och bedömer hur varje intressent skulle ta emot varje alternativ. Markerat är det som minst motsätts, inte bara det populäraste.",
    pairLabel: "Motstridigt lösningspar",
    draft: "Skapa hybrider",
    draftAgain: "Skapa nya hybrider",
    drafting: "AI:n skissar hybrider…",
    error: "Det gick inte att skapa hybrider: {{message}}",
    needPersonas: "Skapa först personorna: stödet bedöms utifrån deras mål.",
    fromA: "Från A: {{text}}",
    fromB: "Från B: {{text}}",
    objection: "Starkaste invändningen ({{name}}): {{text}}",
    mark: { least: "Minst motsatt", popular: "Populärast" },
    support: "Stöd per intressent",
    objections: "Motsätts av",
    total: "Totalt",
    legend: "−2 motsätter sig starkt, −1 motsätter sig, 0 kan godta, +1 stöder, +2 stöder starkt.",
    balanceTitle: "Finlands balans",
    balanceIntro: "Samma fråga ovanför varje enskild intressent: vad gör varje alternativ för Finland som helhet och för världen? Koldioxidläckage medräknat: om Finland gör mindre, vart flyttar produktionen, och om mer, vad ersätter det?",
    balance: "Räkna ut Finlands balans",
    balanceAgain: "Räkna om",
    balancing: "AI:n bedömer…",
    balanceError: "Bedömningen misslyckades: {{message}}",
    unsourced: "AI:ns uppskattning utan källor: inget forskningsmaterial är kopplat till labbet. En blek cell betyder låg säkerhet; håll muspekaren över en cell för motiveringen.",
    scope: { national: "Finland", global: "Världen" },
    confidence: { low: "låg säkerhet", medium: "måttlig säkerhet", high: "hög säkerhet" },
    leakage: "Koldioxidläckage och förflyttat avverkningstryck",
  },
  veil: {
    title: "Okunnighetens slöja",
    intro: "Varje persona rangordnar lösningarna två gånger: först som sig själv, sedan bakom slöjan, utan att veta vems plats i Finland den hamnar på, eller om den föds först år 2060. När ingen försvarar sin egen plats, vad stiger och vad sjunker?",
    vote: "Rösta bakom slöjan",
    voteAgain: "Rösta igen",
    voting: "Personorna röstar…",
    error: "Omröstningen misslyckades: {{message}}",
    missing: "Dessa rangordningar var ofullständiga och är inte med: {{names}}",
    needPersonas: "Skapa först personorna: en omröstning behöver minst två.",
    ownRound: "Som sig själva",
    veilRound: "Bakom slöjan",
    agreement: "Enighet: som sig själva → bakom slöjan",
    agreementHint: "Den genomsnittliga korrelationen mellan personornas rangordningar: 1 är samma ordning, 0 inget samband, −1 motsatt.",
    perPersona: "Vad som ändrades för var och en",
    topPick: "Förstaval: {{own}} → {{veil}}",
  },
  redLines: {
    title: "Röda linjer",
    intro: "Varje axel visar hur långt varje intressent är beredd att gå (den röda linjen) och vad den strävar efter (punkten). Det gröna bandet är det som alla godtar. Där det saknas korsar de röda linjerna varandra, och någon måste kompenseras på en annan axel.",
    zone: "Gemensamt område: {{lo}} – {{hi}}",
    noZone: "Inget gemensamt område: {{a}} och {{b}} möts inte",
    noLines: "Ingen drar en röd linje på denna axel.",
    today: "nu",
    legend: { redLine: "röd linje", ideal: "mål", zone: "gemensamt område", today: "nuläge" },
    packagesTitle: "Paketlösningar",
    packagesIntro: "AI:n föreslår byteshandel över axlarna: en intressent ger efter där det betyder mindre för den och vinner där det betyder mest. Varje paket kontrolleras med mixerns modell mot varje röd linje.",
    propose: "Föreslå paketlösningar",
    proposeAgain: "Föreslå nya paket",
    proposing: "AI:n formulerar paket…",
    error: "Det gick inte att föreslå paket: {{message}}",
    needPersonas: "Skapa först personorna: paketen bygger på deras mål och röda linjer.",
    gives: "ger efter",
    gets: "får",
    checkOk: "Kontroll: ingen intressents röda linje passeras.",
    checkBreached: "Kontroll: den röda linjen passeras för {{count}} intressenter: {{names}}",
    overCeiling: "Kontroll: paketet överskrider taket för hållbar virkestillgång.",
    levers: "Virkesanvändning {{harvest}}, skydd {{protected}} %, massa {{pulp}} %, sågade varor {{solid}} %, nya bioprodukter {{newBio}} %",
    tryInMixer: "Prova i mixern",
  },
  personas: {
    title: "Intressenter",
    intro: "Varje intressent har en persona: vad den strävar efter, vad som är viktigt för den och var den inte ger efter.",
    generate: "Skapa personor",
    regenerate: "Skapa nya personor",
    generating: "AI:n skapar personor…",
    error: "Det gick inte att skapa personorna: {{message}}",
    missing: "AI:n skapade ingen persona för: {{names}}",
    none: "Inga personor ännu. Mixern fungerar utan dem, men nöjdhetsmätarna behöver dem.",
    cares: "Viktigast",
    ideal: "mål {{value}}",
    redLine: "röd linje {{value}}",
    noRedLine: "ingen röd linje",
  },
  mixer: {
    title: "Skogsmixern",
    intro: "Reglagen fördelar årets virkesanvändning och bestämmer skyddsnivån. Varje ändring syns direkt i de nationella siffrorna och i intressenternas nöjdhet.",
    levers: "Reglage",
    harvest: "Skogsindustrins virkesanvändning",
    protected: "Skyddad andel av skogen",
    split: "Vart virket går",
    route: { pulp: "Massa och kartong", solid: "Sågade varor och plywood", newBio: "Nya bioprodukter" },
    outcome: "Finlands siffror",
    today: "nu {{value}}",
    ceiling: "Taket för hållbar virkestillgång: {{value}} Mm³/år",
    overCeiling: "Virkesanvändningen överskrider taket för hållbar virkestillgång vid denna skyddsnivå.",
    jump: {
      baseline: "Nuläget",
      maximin: "Rättvisaste kompromissen",
      total: "Största totala nyttan",
    },
    jumpHint: {
      maximin: "Söker den blandning där så få röda linjer som möjligt passeras och den som klarar sig sämst är så nöjd som möjligt.",
      total: "Söker den blandning där summan av nöjdheten är störst, även om någon hamnar bortom sin röda linje.",
    },
    fromPackage: "Paketlösning från Röda linjer: {{title}}",
    searching: "Söker…",
    noFit: "Ingen blandning ryms under taket för hållbar virkestillgång.",
    gauges: "Nöjdhet",
    gaugesEmpty: "Skapa personor för att se hur varje intressent ser på den valda blandningen.",
    status: { red: "Röd linje passerad", amber: "Missnöjd", green: "Nöjd" },
    breached: "Passerad: {{axes}}",
    summary: "Total nöjdhet {{total}} / {{count}} · den som klarar sig sämst {{min}} %",
  },
  axis: {
    harvest: "Virkesanvändning",
    exports: "Exportintäkter",
    jobs: "Arbetstillfällen",
    climate: "Skogsmarkens nettoutsläpp",
    protected: "Skydd",
    newBio: "Andel till nya bioprodukter",
  },
  unit: { harvest: "Mm³/år", exports: "mdr €", jobs: "t. pers.", climate: "Mt CO₂e", protected: "%", newBio: "%" },
  climateNote: "En positiv siffra är en utsläppskälla, en negativ en sänka.",
  assumptions: {
    title: "Modellens antaganden",
    intro: "Utgångsvärdena är statistik. Koefficienterna är modellens antaganden, inställda så att de återger nuläget. Modellen åskådliggör avvägningar, den förutspår inte.",
    exportPerM3: "Exportvärde per m³: massa och kartong {{pulp}} €, sågade varor och plywood {{solid}} €, nya bioprodukter {{newBio}} €.",
    jobsPerMm3: "Arbetstillfällen per miljon m³: skogsbruk {{forestry}} t., industri {{industry}} t., nya bioprodukter {{newBio}} t.",
    climatePerMm3: "Varje miljon m³ som avverkas utöver dagens nivå ökar skogsmarkens nettoutsläpp med {{value}} Mt CO₂e.",
    productStorage: "Långlivade träprodukter lagrar kol: {{value}} Mt CO₂e per miljon m³ som styrs till sågade varor.",
    newBioValue: "Värdet och sysselsättningen för nya bioprodukter är uppskattningar för produkter som först nu börjar nå marknaden.",
    newBioCap: "Högst {{value}} % av virket kan gå till nya bioprodukter: marknaderna och tekniken bär inte mer ännu.",
    ceiling: "Taket för hållbar virkestillgång är den största hållbara avverkningen vid dagens skyddsnivå, och det sjunker när skyddet ökar.",
    sources: "Källor",
  },
};
